import styled from 'styled-components';

import { AbsoluteImage } from './AbsoluteImage';

export interface InputStyledProps {
  width?: string;
  marginBottom?: number;
  marginTop?: number;
  marginLeft?: number;
  marginRight?: number;
  height?: string;
  autocomplete?: string;
  margin?: string;
}

export const TextAreaStyled = styled.textarea<InputStyledProps>`
  box-sizing: border-box;
  position: relative;
  height: 100%;
  width: 100%;
  transition: 0.3s;
  color: ${({ theme }) => theme.colors.black};
  font-weight: bold;
  cursor: pointer;
  outline: none;
  padding: 17px;
  border: none;
  resize: none;
`;

export const PlaceHolderIcon = styled(AbsoluteImage)`
  right: 20px;
  top: 30%;
`;
